import { tableFiltersUrl } from '../../utils/helper'
import request from '../axiosInterceptor'

const api = {
  postAddTheme(data: any) {
    return request({
      url: `${process.env.REACT_APP_API_BASEURL}v1/theme-management/add-theme`,
      method: 'post',
      data: data,
    })
  },
  getThemeById(id: string) {
    return request({
      url: `${process.env.REACT_APP_API_BASEURL}v1/theme-management/get-theme-by-id?theme_id=${id}`,
      method: 'get',
    })
  },
  getAllThemes(data: any) {
    return request({
      url: `${process.env.REACT_APP_API_BASEURL}v1/theme-management/theme-list?${tableFiltersUrl(data)}`,
      method: 'get',
    })
  },
}

export default api
